import { useProject } from './useProject';

export const useQueryAllowed = (queryKey: string): boolean => {
    const { queries = [] } = useProject();

    return queries.includes(queryKey);
};
